import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ConstantValues } from "common/constants";

interface IAIGenerateState {
  value: string;
  isGenerating: boolean;
}

const initialState: IAIGenerateState = {
  value: ConstantValues.EMPTY_STRING,
  isGenerating: false,
};

export const aiGeneratedMessageSlice = createSlice({
  name: "currentConversation",
  initialState,
  reducers: {
    addValueToAIGenerateMessage: (state, action: PayloadAction<string>) => {
      state.value = action.payload;
    },
    resetAIGeneratedMessageSlice: (state) => {
      state.value = ConstantValues.EMPTY_STRING;
    },
    setIsGenerating: (state, action: PayloadAction<boolean>) => {
      state.isGenerating = action.payload;
    },
  },
});

export const {
  addValueToAIGenerateMessage,
  resetAIGeneratedMessageSlice,
  setIsGenerating,
} = aiGeneratedMessageSlice.actions;

export default aiGeneratedMessageSlice.reducer;
